import { Waves, Eye, Sparkles, MessageCircle } from "lucide-react";

const SERVICES = [
  {
    icon: Waves,
    title: "Somatic Experiencing (SE)",
    text:
      "Ein körperorientierter Ansatz zur Verarbeitung und Regulation von Stress- und Traumaerfahrungen. Die natürliche Selbstregulation des Nervensystems wird behutsam wieder in Bewegung gebracht.",
  },
  {
    icon: Eye,
    title: "EMDR — Eye Movement Desensitization and Reprocessing",
    text:
      "Eine wissenschaftlich anerkannte Methode zur Verarbeitung traumatischer Erfahrungen. Durch bilaterale Stimulation wird die natürliche Verarbeitung im Gehirn unterstützt, sodass emotionale Belastungen nachhaltig reduziert werden können.",
  },
  {
    icon: Sparkles,
    title: "PEP — Prozess- und Embodimentfokussierte Psychologie",
    text:
      "Eine ressourcenorientierte Methode zur Reduzierung von emotionalem Stress, inneren Blockaden und belastenden Glaubenssätzen.",
  },
  {
    icon: MessageCircle,
    title: "Gesprächstherapie",
    text:
      "In einer vertrauensvollen Atmosphäre werden persönliche Anliegen empathisch und wertschätzend reflektiert, eigene Ressourcen gestärkt und individuelle Lösungswege entwickelt.",
  },
];

export default function Leistungen() {
  return (
    <section
      id="leistungen"
      data-testid="leistungen-section"
      className="relative py-24 lg:py-32"
      style={{ background: "var(--cream-deep)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <p className="eyebrow reveal">Leistungen</p>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 reveal reveal-delay-1"
            style={{ color: "var(--ink)" }}
          >
            Methoden, die <em className="font-serif italic" style={{ color: "var(--sky-deep)" }}>zu Ihnen passen</em>.
          </h2>
          <p
            className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed reveal reveal-delay-2"
            style={{ color: "var(--ink-soft)" }}
          >
            Jeder Mensch ist anders — deshalb wähle ich gemeinsam mit Ihnen den Ansatz, der sich
            stimmig anfühlt. Die folgenden Methoden bilden den Kern meiner Arbeit.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 gap-6 lg:gap-8" data-testid="leistungen-grid">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                data-testid={`leistung-card-${idx}`}
                className={`soft-card p-7 lg:p-9 reveal reveal-delay-${Math.min((idx % 4) + 1, 5)}`}
              >
                <span className="icon-tile">
                  <Icon size={26} strokeWidth={1.5} />
                </span>
                <h3
                  className="font-serif text-2xl mt-6"
                  style={{ color: "var(--ink)" }}
                >
                  {s.title}
                </h3>
                <p
                  className="mt-3 text-[15px] leading-relaxed"
                  style={{ color: "var(--ink-soft)" }}
                >
                  {s.text}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
